<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader

    main.primary--text
      v-container
        h1 店舗・施設の方へ
      v-layout(row wrap)
        v-flex
         h2 ジューシーズ専用冷凍庫を無料で
           br.xs
           | お貸し致します!
         p.text-xs-center.mb-5(style="font-size: 1.2rem;line-height:1.7rem;")
           | 店舗内外、施設内外、移動販売等で
           br
           | 冷凍庫を使ってジューシーズを
           br.xs
           | 販売してみませんか？
         div.top_image
           v-parallax(src="static/images/freezer_bg.jpg")
           v-flex.freezer(xs6 offset-xs6 sm4 md5)
             v-img(src="static/images/freezer.png" alt="Juicies冷凍庫" contain max-width="400px")
        v-layout.mt-5.justify-center(row wrap)
          v-flex(xs12)
            h2 様々な場所で設置・販売いただけます。
          v-container
            v-layout(row wrap)
              v-flex.pa-2(v-for='card in cards', :key='card.title', v-bind='{ [`xs${card.flex}`]: true }')
                v-card
                  v-img(:src='card.src', height='350px')
                    v-container(fill-height fluid)
                      v-layout(fill-height)
                        v-flex(xs12 align-end flexbox)
                  v-card-actions.pa-3
                    v-spacer
                      i.material-icons.secondary--text.mt-1(style="float:left;")
                        | place
                      h3.primary--text(v-text='card.title')
                      p.primary--text.text-xs-left.px-1(v-text='card.text')

            v-layout(row wrap).px-2
              v-flex.pt-5.pb-3(xs12)
                v-card.primary--text.pa-4
                  i.material-icons.secondary--text(style="float:left;")
                    | storage
                  h2.text-xs-left 設置事例
                  v-flex
                    ul
                      li.py-3(v-for="item in list" xs12 sm6 md4 :key="item.place")
                        p.pb-1 {{ item.place }}
                        span {{ item.pref }}
                    p.mt-2(style="font-size: .7rem") ※現在取り扱っていない所もございます。（順不同）
              v-flex(xs12)
                v-card.primary--text.pa-4
                  i.material-icons.secondary--text(style="float:left;")
                    | build
                  h2.text-xs-left 仕様
                  v-flex
                    dl(v-for="item in detail" xs12 sm6 md4 :key="item.title")
                      dt.py-3 {{ item.title }}
                      dd.py-3 {{ item.content }}
                    p.mt-2(style="font-size: .7rem") ※導入条件については、お問い合わせください。

        v-layout#contact.mt-5.text-xs-center(row wrap)
          v-flex.mt-5(xs12)
            h2.mt-5 お問い合せ
            v-flex.my-2.justify-center(xs12 sm4 offset-sm4)
              a(href="http://www.otani-shokai.com/")
                img(src="static/images/trading_logo.png" alt="大谷商会ロゴ" width="150px")
            p.mb-1 [輸入販売元]
            h3 株式会社大谷商会 国際部
            address.my-2 〒950-0814 新潟県新潟市東区逢谷内463
              br
              span TEL 025-275-8185
              span.mr-1 FAX 025-275-8186
            a.primary--text(href="mailto:kokusai@otani-shokai.com").mail E-mail: kokusai@otani-shokai.com
            br
            a.my-3.brown--text.lighten-3(href="http://www.otani-shokai.com/") www.otani-shokai.com

    CommonFooter
    span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
  },
  data () {
    return {
      cards: [{
        src: require('@/../static/images/freezer_leisure.jpg'),
        title: 'レジャー施設',
        text: '持ちやすいパッケージで遊園地やイベント施設等で楽しんでいただけます。'
      }, {
        src: require('@/../static/images/freezer_sea.jpg'),
        title: 'マリンレジャー施設・海の家',
        text: '後味がすっきりしており、マリンレジャー中にぴったりの商品です。'
      }, {
        src: require('@/../static/images/freezer_outdoor.jpg'),
        title: 'キャンプ場・アウトドア関連施設',
        text: 'シンプル素材のジューシーズは自然の中で食べるのにぴったり。持ちやすく汚れにくいのも嬉しい。'
      }, {
        src: require('@/../static/images/freezer_onsen.jpg'),
        title: '入浴施設',
        text: '身体にやさしい冷たいシャーベットは、お風呂上がりのお客様へもおすすめです。'
      }, {
        src: require('@/../static/images/freezer_sa.jpg'),
        title: 'サービスエリア',
        text: '持ちやすく汚れにくいので車内や食べ歩きにもおすすめです。'
      }, {
        src: require('@/../static/images/freezer_sports.jpg'),
        title: 'スポーツ関連施設',
        text: '砂糖甘味料不使用が嬉しい！運動の前後に気持ちよく身体を冷やしてくれます。'
      }, {
        src: require('@/../static/images/freezer_trailer.jpg'),
        title: '移動販売',
        text: '食べ歩きしやすいパッケージ。他の飲食と合わせてバラエティーを増やしてみませんか？'
      }, {
        src: require('@/../static/images/freezer_shop.jpg'),
        title: 'バラエティーショップ',
        text: '有名ショップでの販売実績もあり、若い方にも喜んでいただけています。'
      }],
      list: [{
        place: '温浴施設',
        pref: '（京都府・宮城県・東京都・埼玉県・神奈川県・千葉県・茨木県・岐阜県・愛知県・静岡県・大阪府・広島県・岡山県・山口県・三重県・福岡県・佐賀県・長崎県）'
      }, {
        place: '高速道路サービスエリア',
        pref: '（香川県・宮崎県・静岡県・埼玉県・神奈川県・東京都・栃木県・千葉県・福島県・長野県・群馬県）'
      }, {
        place: '観光・レジャー施設',
        pref: '（神奈川県・大阪府・東京都・大阪府・兵庫県・三重県・神奈川県・千葉県）'
      }, {
        place: 'マリンレジャー施設・海の家',
        pref: '（新潟県・宮城県）'
      }, {
        place: 'キャンプ場・アウトドア関連施設',
        pref: '（大阪府・福岡県）'
      }, {
        place: 'ゴルフ場',
        pref: '（埼玉県・愛知県・滋賀県・静岡県・兵庫県・大阪府・千葉県・奈良県・栃木県・東京都・茨木県・和歌山県・岐阜県・三重県・広島県）'
      }, {
        place: 'スポーツジム',
        pref: '（神奈川県）'
      }, {
        place: 'バラエティショップ',
        pref: '（富山県・東京都・宮崎県・長野県・岐阜県・愛知県・千葉県・京都府・石川県・鹿児島県・佐賀県・福岡県・熊本県・福井県・新潟県・群馬県・栃木県・滋賀県・長崎県）'
      }],
      detail: [{
        title: '収容可能ケース数',
        content: '14ケース'
      }, {
        title: '外装サイズ',
        content: 'W584 ×D694 ×H850'
      }, {
        title: '重量',
        content: '48kg'
      }, {
        title: '注意事項',
        content: '漏電遮断器を同送させていただきますので、コンセントに取り付けてご使用ください。'
      }]
    }
  }
}

</script>

<style scoped lang="stylus">

// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}

.top_image
  position relative
  width 100%
  height 500px
  +breakpoint(sm)
    height 300px
  .flex
    position absolute
    width 100%
    height 500px
    bottom -90px
    +breakpoint(sm)
      height 300px
      bottom -30px
.v-parallax
  +breakpoint(sm)
    height 250px !important
h3
  font-size 1.2rem
  padding 8px 0
.v-card
  font-size 0.9rem
  .v-image
    +breakpoint(xs)
      height 250px !important
  h2
    margin -1px 0 30px 30px
    +breakpoint(xs)
      margin-top 2px
  dt,dd
    padding 5px 5px 5px 0
  dd,li
    border-bottom 1px solid #ccc
  dt
    width 10rem
    float left
    +breakpoint(sm)
      display block
      float none
      padding-bottom 0 !important
    +breakpoint(md-up)
     border-bottom 1px solid #ccc
#contact
  img
    margin 0 auto
  a
    text-decoration none
//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_chara_c.png) no-repeat
  background-position bottom 0 right -15px

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Freezer/index.vue